// css
import classes from "./BrandsListItem.module.css";

const BrandListItem = ({ imageSource }) => (
  <li className={["shrink-0", classes.BrandContainer].join(" ")}>
    <img
      src={imageSource}
      alt="mtor sku brand"
      className="w-44 h-44 object-contain	object-center"
    />
  </li>
);

export default BrandListItem;
